module.exports = __webpack_public_path__ + "static/media/exclamation.8773ca7e.svg";